var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriteWhat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5988_28110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5932 10.8205L27.7395 7.9668L8.26367 27.4426H8.46654C9.15631 27.4426 9.84608 27.7401 10.4276 28.227C10.9145 28.7139 11.2121 29.4037 11.2121 30.1881V30.391L30.5932 10.8205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38462 25.7788L26.4682 6.69523L24.3042 4.53125L4.9231 23.8988C5.61286 23.8988 6.19443 24.1964 6.69485 24.6833C6.9924 24.9808 7.28994 25.373 7.38462 25.7653",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.879115 35.2188L0 38.37L3.15129 37.4909C3.05662 36.8958 2.75907 36.4089 2.36685 36.0167C1.97463 35.6245 1.48773 35.3269 0.89264 35.2323",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.572 5.80216L32.7572 0.987314C32.0674 0.297547 31.283 0 30.4038 0C29.5247 0 28.6321 0.392221 28.0505 0.987314L25.7919 3.24596L35.4351 12.8892L37.6937 10.6305C38.3835 9.94077 38.6811 9.15633 38.6811 8.26368C38.5864 7.27637 38.1942 6.39725 37.5991 5.80216",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6863 31.0797C13.0785 31.1743 13.4707 31.4719 13.7683 31.7694C14.2552 32.2563 14.5527 32.8514 14.5527 33.5412L33.9338 14.1601L31.7698 11.9961L12.6863 31.0797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1047 32.4601H10.5359C10.2383 32.4601 10.049 32.3654 9.84609 32.1625C9.64322 31.9596 9.54854 31.6756 9.54854 31.4728V29.9039C9.54854 29.6063 9.45387 29.417 9.251 29.2141C9.04812 29.0112 8.7641 28.9166 8.56123 28.9166H6.99235C6.6948 28.9166 6.50545 28.8219 6.30258 28.619C6.09971 28.4161 6.00503 28.2268 6.00503 27.9292V26.3604C6.00503 26.0628 5.91036 25.8735 5.70748 25.6706C5.51814 25.4677 5.22059 25.373 5.01772 25.373H3.44884L1.19019 33.7314C2.0693 33.9208 2.86727 34.3265 3.44884 35.0163C4.04393 35.5978 4.53082 36.3958 4.7337 37.2749L13.0921 35.0163V33.4339C13.0921 33.1363 12.9974 32.947 12.7945 32.7441C12.5916 32.5412 12.3076 32.4465 12.1047 32.4465",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5988_28110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.654,
    height: 38.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteWhat);
export default __webpack_public_path__ + "static/media/writeWhat.5527d334c336fc85fc4683e64a62bfdc.svg";
export { ForwardRef as ReactComponent };